import { NullableClassName } from '@squareup/dex-types-shared-ui';
import { Box } from '@squareup/dex-ui-shared-base';
import clsx from 'clsx';
import React, { FC } from 'react';

import styles from './attention-marker.module.css';

interface Props {}

const AttentionMarker: FC<Props & NullableClassName> = ({ className }) => {
  return (
    <Box
      className={clsx(className, styles['marker-container'])}
      testId="attn-marker"
    >
      <Box />
      <Box className={styles['marker-pulse']} />
    </Box>
  );
};

export { AttentionMarker };
